import component from './selectTreeSegments.vue'

export default component
